/*
 * @Description:
 * @Author: Xyyyyyy
 * @Date: 2023-06-26 14:58:19
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-06-26 14:58:22
 */
/*
 * @Description: 公共 api
 * @Author: 裴孚
 * @Date: 2023-01-29 18:32:53
*/
import request from '@/api/request'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { ElMessageBox, ElLoading } from 'element-plus'
import requestDownload from '@/utils/requestDownload'
const fileurl = process.env.VUE_APP_BASE_API

// export function paramsapi (url, params) {
//   return request({
//     url,
//     params,
//     method: 'GET'
//   })
// }

/** -------------------------------------------- */

export function actionGet (options) {
  options.method = 'GET'
  return request(options)
}
export function actionPost (options) {
  options.method = 'POST'
  return request(options)
}
export function actionPatch (options) {
  options.method = 'PATCH'
  return request(options)
}
export function actionDelete (options) {
  options.method = 'DELETE'
  return request(options)
}

/** -------------------- 数据加载区 ------------------------ */

// 获取分页列表
export function loadList (options) {
  const dataGrid = options.dataGrid
  if (dataGrid.orderBy) {
    dataGrid.parms.order = dataGrid.orderBy.prop || 'createdTime' // 排序条件
    dataGrid.parms.sort = dataGrid.orderBy.order === 'ascending' ? 'asc' : 'desc' // 排序方式 ascending descending
  }
  dataGrid.parms.pageNo = options.pageNo // 当前页数
  dataGrid.parms.pageSize = options.pageSize // 每页条数
  dataGrid.parms.menuId = sessionStorage.getItem('menuId')
  const o = { url: options.url, data: dataGrid.parms } // [url]接口地址 [parms]查询数据
  dataGrid.loading = true // 开始加载
  actionPost(o).then((res) => {
    dataGrid.loading = false // 结束加载
    dataGrid.pagination = { // 返回分页所需数据
      pageNo: options.pageNo || 1,
      pageSize: options.pageSize || 100,
      pagerCount: options.pagerCount ? options.pagerCount : 11, // 最大页码按钮数
      layout: options.layout || '', // 组件布局
      total: res.data.total
    }
    dataGrid.data = res.data.list // 返回列表
    if (options.loadSuccess) {
      options.loadSuccess(res) // 加载成功后执行
    }
  })
}
// 获取详情
export function loadData (options) {
  const data = options.data
  const ruleForm = options.ruleForm
  const o = { url: options.url }
  if (data) {
    data.menuId = sessionStorage.getItem('menuId')
    o.data = data
  }
  actionPost(o).then((res) => {
    ruleForm.value = res.data // 返回列表
    if (options.loadSuccess) {
      options.loadSuccess(res) // 加载成功后执行
    }
  })
}
// 加载下拉框
export function loadSelect (options) {
  const data = options.data
  const o = { url: options.url, data: {} }
  if (options.parms) {
    o.data = options.parms
  }
  if (options.order) {
    o.data.order = options.order || 'createdTime'
    o.data.sort = options.sort || 'asc'
  }
  o.data.menuId = sessionStorage.getItem('menuId')
  actionPost(o).then((res) => {
    data.value = res.data // 返回列表
    if (options.loadSuccess) {
      options.loadSuccess(res)
    }
  })
}

/** ---------------------- 功能区 ---------------------- */

// 删除
export function submitDelete (url, dataGrid, callback) { // [url]接口地址 [ids] [callback]回调
  const ids = dataGrid.multipleSelection
  if (ids.length === 0) {
    warningPrompt('至少选择一行')
    return
  }
  ElMessageBox.confirm('确定要删除吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    const loading = ElLoading.service({
      lock: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    const data = { ids: ids, menuId: sessionStorage.getItem('menuId') }
    const options = { url: url, data: data } // [url]接口地址 [data]
    actionDelete(options).then((res) => {
      loading.close()
      if (res.code === 200) {
        if (callback) {
          callback(res) // 成功后回调
        }
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  })
}

// 提交表格
export function submitDataGridAction (options) { // [url]接口地址 [ids] [callback]回调
  const url = options.url; const dataGrid = options.dataGrid; const callback = options.callback
  const confirmTitle = options.confirmTitle
  const ids = dataGrid.multipleSelection
  const method = options.method ?? 'post'
  if (ids.length === 0) {
    warningPrompt('至少选择一行')
    return
  }
  if (confirmTitle) {
    ElMessageBox.confirm(confirmTitle, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      submitDataGridAction_action(url, ids, callback, method)
    })
  } else {
    submitDataGridAction_action(url, ids, callback, method)
  }
}
// eslint-disable-next-line camelcase
export function submitDataGridAction_action (url, ids, callback, method) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const data = { ids: ids, menuId: sessionStorage.getItem('menuId') }
  const options = { url: url, data: data } // [url]接口地址 [data]
  // const url = options.url,
  // const callback = options.callback
  if (method === 'post') {
    actionPost(options).then((res) => {
      loading.close()
      if (res.code === 200) {
        if (callback) {
          callback(res) // 成功后回调
        }
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  }
  if (method === 'delete') {
    actionDelete(options).then((res) => {
      loading.close()
      if (res.code === 200) {
        if (callback) {
          callback(res) // 成功后回调
        }
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  }
}
// 添加
export function submitForm (options) {
  const form = options.ruleFormRef
  if (form) {
    form.validate((valid, fields) => {
      if (valid) {
        options.ruleForm.menuId = sessionStorage.getItem('menuId')
        const o = { url: options.url, data: options.ruleForm } // [url]接口地址 [data]获取表单数据
        const loading = ElLoading.service({
          lock: true,
          text: 'Loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        actionPost(o).then((res) => {
          loading.close()
          if (res.code === 200) {
            if (options.callback) {
              options.callback(res) // 成功后回调
            }
            successPrompt(res.message)
          } else {
            warningPrompt(res.message)
          }
        })
      } else {
        return console.log('error submit!', fields)
      }
    })
  }
}
// 编辑
export function submitEditForm (options) {
  const form = options.ruleFormRef
  if (form) {
    form.validate((valid, fields) => {
      if (valid) {
        options.ruleForm.menuId = sessionStorage.getItem('menuId')
        const o = { url: options.url, data: options.ruleForm } // [url]接口地址 [data]获取表单数据
        const loading = ElLoading.service({
          lock: true,
          text: 'Loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        actionPatch(o).then((res) => {
          loading.close()
          if (res.code === 200) {
            if (options.callback) {
              options.callback(res) // 成功后回调
            }
            successPrompt(res.message)
          } else {
            warningPrompt(res.message)
          }
        })
      } else {
        return console.log('error submit!', fields)
      }
    })
  }
}

// 关闭
// [window]窗体名称 [emits]触发开关 [isRefresh]关闭后是否刷新
export function closeWindow (window, emits, isRefresh) {
  emits('update:' + window, false)
  if (isRefresh) {
    emits('ReturnData')
  }
}

export function downloadTemplate (url, dataGrid) {
  // const loading = ElLoading.service({
  //   lock: true,
  //   text: 'Loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  requestDownload.exportExcel(url, dataGrid)
}
export function exportExcel (url, dataGrid) {
  if (dataGrid.orderBy) {
    dataGrid.parms.order = dataGrid.orderBy.prop || 'createdTime' // 排序条件
    dataGrid.parms.sort = dataGrid.orderBy.order === 'ascending' ? 'asc' : 'desc' // 排序方式
  }
  requestDownload.exportExcel(url, dataGrid.parms)
}

export function submitExcel (options) {
  console.log(options)
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const formData = new FormData()
  formData.append('parms', options.file.parms)
  formData.append('file', options.file.file)
  const o = { url: options.url, data: formData } // [url]接口地址 [data]获取表单数据
  actionPost(o).then((res) => {
    loading.close()
    if (res.code === 200) {
      if (options.callback) {
        options.callback(res) // 成功后回调
      }
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
